module.exports = __webpack_public_path__ + "img/bess_item-v2.00a33c5d.svg";